import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SegmentCategoryControl} from "../../../interface/segment-category-control";
import {SubCategoryControls} from "../../../interface/sub-category-controls";
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'fb-nested-filter-config',
    templateUrl: './nested-filter-config.component.html',
    styleUrls: ['./nested-filter-config.component.scss']
})
export class NestedFilterConfigComponent implements OnInit {

    @Input() public control: SegmentCategoryControl[] = [];
    @Output() public onControlChange: EventEmitter<null> = new EventEmitter<null>();
    public collapse: boolean = false;
	public isFabric = false
	public isSearchPage = false
	constructor(
		private _activatedRoute: ActivatedRoute
	){}

    public toggleCollapse(): void {
        this.collapse = !this.collapse;
    }

    public onChange(segmentIndex: number): void {
        if(this.control[segmentIndex].activated){
            this.control[segmentIndex].options.forEach((subCat:SubCategoryControls): void=>{
                subCat.activated = true;
            })
        }
        if(!this.control[segmentIndex].activated) {
            this.control[segmentIndex].options.forEach((subCat:SubCategoryControls): void=>{
                subCat.activated = false;
            })
        }
        this.onControlChange.emit(null);
    }

    public onChangeSub(
        segmentIndex: number,
        subCategories: SubCategoryControls[],
    ): void {

        let isAllChecked: boolean = false;

        for (let i = 0; i < subCategories.length; i++) {
            if (!subCategories[i].activated) {
                isAllChecked = false;
                break
            } else isAllChecked = true;
        }
        this.control[segmentIndex].activated = isAllChecked;

        this.onControlChange.emit(null);
    }


    public ngOnChanges(): void {
        // debugger
        this.control.forEach((segment: SegmentCategoryControl, segmentIndex: number,) => {

            let isAllChecked: boolean = false;

            for (let i = 0; i < segment.options.length; i++) {
                if (!segment.options[i].activated) {
                    isAllChecked = false;
                    break;
                } else isAllChecked = true;

            }

            this.control[segmentIndex].activated = isAllChecked;
        });
    }

	public ngOnInit(): void {
		this._activatedRoute.params.subscribe(params => {
			// debugger
			// console.log(params)
			if(params['category']==='finished'){
				this.isFabric = false;
			}
			if(params['category']==='search'){
				this.isSearchPage = true;
			}

			if( params['category'] === 'fabric'){
				this.isFabric = true;
			}
		})

	}
}
